import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  isLoading: false,
};

const createPostSlice = createSlice({
  name: 'createPost',
  initialState,
  reducers: {
    storeSetIsLoadingCreatePost: (state: any, { payload }: PayloadAction<any>) => {
      state.isLoading = payload;
    },
  },
});

export const { storeSetIsLoadingCreatePost } = createPostSlice.actions;

export default createPostSlice.reducer;
